import * as React from 'react';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconTimerCompletedSvg } from './IconTimerCompletedSvg';

type TimerCompletedState = 'active' | 'warning' | 'critical';

export type IconTimerCompletedProps = UseIconProps & {
  state: TimerCompletedState;
};

export function IconTimerCompleted({
  state,
  ...props
}: IconTimerCompletedProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <IconTimerCompletedSvg {...iconProps} state={state} />;
}
